import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { PartenaireService } from '../../../@core/data/rest/partenaire/partenaire-service';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { Partenaire } from '../../../@core/data/model/partenaire';
import { PlanTarifaireService } from '../../../@core/data/rest/plantarifaire/plantarifaire-service';
import { CashSessionService } from '../../../@core/data/rest/caisse/cashsession-service';
import { CashSession } from '../../../@core/data/model/cashsession';
import { AuthService } from '../../../auth/auth.service';
import { PartenaireFormComponent } from '../../partenaire/partenaireform/partenaireform.component';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-session-form',
  templateUrl: './sessionform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class SessionFormComponent implements OnInit {

  @Input() sessionEdit: CashSession;
  @Input() naturesToExclude: string[];

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  naturescompte = [
    {label: 'Banque', value: 'banque'},
    {label: 'Espèce', value: 'espece'},
    {label: 'Emprunt/Prêt', value: 'credit'},
    {label: 'Dépôt', value: 'depot'},
  ];


  constructor(
      protected dialogRef: NbDialogRef<SessionFormComponent>,
      public authService: AuthService,
      private dialogService: NbDialogService,
      public partenaireService: PartenaireService,
      public cashSessionService: CashSessionService,
      public sharedMethods: SharedMethods) {



  }


  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    this.naturesToExclude.forEach ( elem => {
      const index = this.naturescompte.findIndex( item => item.value === elem);
      if (index > -1)
      this.naturescompte.splice(index, 1);
    });

    /* if (this.sessionEdit.nature === undefined && this.naturescompte.length > 0)
    this.sessionEdit.nature = this.naturescompte[0].value; */

    // gestion compte dépot
    /* if ( !this.authService.token.company.gestion_compte_depot) {
      const index = this.naturescompte.findIndex( item => item.value === 'depot');
      if (index > -1)
      this.naturescompte.splice(index, 1);
    } */


    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'labelPartenaire',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'recherche',
      noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
      closeDropDownOnSelection: true,
    };

    // chargement des parteanires
    if (this.partenaireService.getLocalPartner('client') === undefined || this.partenaireService.getLocalPartner('client') === []) {

      this.partenaireService.getPartner('client').then( partners => {

          const pat = [];

          partners.forEach( elem => {

            if ( elem.cash_state_id === null ) {

              pat.push( elem);

            }

          });


          this.dropdownList = pat;

          if (this.sessionEdit.partenaire !== undefined) {

            this.selectedItems = [plainToClass(Partenaire, this.sessionEdit.partenaire)];

          }

      });

    } else {

        const pat = [];

        this.partenaireService.getLocalPartner('client').forEach( elem => {

          if ( elem.cash_state_id === null ) {

            pat.push( elem);

          }

        });

        this.dropdownList = pat;

        if (this.sessionEdit.partenaire !== undefined) {

          this.selectedItems = [plainToClass(Partenaire, this.sessionEdit.partenaire)];

        }

    }



  }


  cancel() {
    if (this.cashSessionService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.partenaireEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    let valid: Validator;
    valid = this.sharedMethods.validateSession(this.sessionEdit);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.cashSessionService.iSconnecting === false) {


            this.cashSessionService.saveSession(this.sessionEdit).then( session => {

                // on met à jour le partenaire
                if (session.partenaire !== null) {

                  const index = this.partenaireService.getLocalPartner('client').findIndex( elem => elem.id === session.partenaire.id );

                  if ( index > -1) {
                    this.partenaireService.getLocalPartner('client')[index].cash_state_id = session.id;
                  }

                }


                this.dialogRef.close(plainToClass(CashSession, session as Object));
                // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

  onItemSelect(item: any) {

    const index = this.partenaireService.getLocalPartner('client').findIndex( elem => elem.id === item.id );

    if ( index > -1) {
      this.sessionEdit.partenaire = this.partenaireService.getLocalPartner('client')[index];
      this.sessionEdit.nom = this.partenaireService.getLocalPartner('client')[index].nom;
    }


    // this.infosFacture.partenaire = item;
    // this.fluxEdit.partenaire = plainToClass(Partenaire, item)[0];

  }

  onDeSelect(item: any) {

    // this.infosFacture.partenaire = null;
    this.sessionEdit.partenaire = null;

  }

  onSelectAll(items: any) {

    // tslint:disable-next-line:no-console
    console.log(items);

  }

  addpartner() {
    const partner = new Partenaire;
    this.editPartner(partner, 'add', 'client', 'Client');
  }

  editPartner(partner: Partenaire, typeEdit: string, typePartenaire: string, labelPartner: string) {

      const closeOnBackdropClick = false;
      this.dialogService.open(PartenaireFormComponent, {
        closeOnBackdropClick,
        context: {
          partenaireEdit : partner,
          typePartenaire : typePartenaire,
          labelPartner: labelPartner,
        },
      }).onClose.subscribe(data => {

          if ( data !== undefined) {

            // on met à jour la partenaire de la facture et le partenaire selectionner
            this.sessionEdit.partenaire = data;
            this.sessionEdit.nom = data.nom;

            this.selectedItems = [
              data,
            ];

           /* if (typeEdit === 'update' )
            this.sourceReglement.update(this.reglementEdit, data);

            if (typeEdit === 'add' )
            this.sourceReglement.prepend(data); */

          }
      });
  }



}
